import { render, staticRenderFns } from "./DeleteAccountStepTree.vue?vue&type=template&id=ab70706c&scoped=true"
import script from "./DeleteAccountStepTree.vue?vue&type=script&lang=js"
export * from "./DeleteAccountStepTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab70706c",
  null
  
)

export default component.exports